export function getDamEnvFromScene7File(scene7File) {
    const parts = scene7File.split('/');
    if (parts.length >= 2) {
        return parts[0];
    }
    return '';
}
